import(/* webpackMode: "eager" */ "/vercel/path0/next/src/components/_global/Breadcrumbs/Breadcrumbs.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/next/src/components/_global/ImageShowcase/_Parallax.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/src/components/ui/Button/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/src/components/_global/ImageShowcase/ImageShowcase.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/src/components/_global/Introduction/Introduction.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next-sanity/dist/visual-editing/VisualEditing.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
